var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14893_8099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.33334C13 5.78106 12.5523 5.33334 12 5.33334C11.4478 5.33334 11 5.78106 11 6.33334V11H6.33337C5.78109 11 5.33337 11.4477 5.33337 12C5.33337 12.5523 5.78109 13 6.33337 13H11L11 17.6667C11 18.219 11.4478 18.6667 12 18.6667C12.5523 18.6667 13 18.219 13 17.6667V13H17.6667C18.219 13 18.6667 12.5523 18.6667 12C18.6667 11.4477 18.219 11 17.6667 11H13V6.33334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14893_8099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.fe0c23b2d8048a16a206487ae24d2a97.svg";
export { ForwardRef as ReactComponent };